import api from "../../services/api";
import {
  GET_CURRENT_LEARNER_FAILURE,
  GET_CURRENT_LEARNER_REQEST,
  GET_CURRENT_LEARNER_SUCCESS,
  GET_LEARNER_FAILURE,
  GET_LEARNER_REQUEST,
  GET_LEARNER_SUCCESS,
  GET_MY_ENROLLED_COURSES_FAILURE,
  GET_MY_ENROLLED_COURSES_REQUEST,
  GET_MY_ENROLLED_COURSES_SUCCESS,
  RESET_ALL_ACTIONS,
  UPDATE_LEARNER_FAILURE,
  UPDATE_LEARNER_REQUEST,
  UPDATE_LEARNER_SUCCESS,
} from "./ActionType";

const getLearnerRequest = () => ({ type: GET_LEARNER_REQUEST });
const getLearnerSuccess = (user) => ({
  type: GET_LEARNER_SUCCESS,
  payload: user,
});
const getLearnerFailure = (error) => ({
  type: GET_LEARNER_FAILURE,
  payload: error,
});

export const getLearner = () => async (dispatch) => {
  dispatch(getLearnerRequest());
  try {
    const response = await api.get(`/learners`);
    const user = response.data;

    dispatch(getLearnerSuccess(user));
  } catch (error) {
    dispatch(getLearnerFailure(error.message));
  }
};

const updateLearnerRequest = () => ({
  type: UPDATE_LEARNER_REQUEST,
});

const updateLearnerSuccess = (user) => ({
  type: UPDATE_LEARNER_SUCCESS,
  payload: user,
});

const updateLearnerFailure = (error) => ({
  type: UPDATE_LEARNER_FAILURE,
  payload: error,
});

export const updateLearner = (user) => async (dispatch) => {
  dispatch(updateLearnerRequest());
  try {
    const response = await api.put(`/learners`, user, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const updatedUser = response.data;
    dispatch(updateLearnerSuccess(updatedUser));
  } catch (error) {
    dispatch(updateLearnerFailure(error.response.data));
  }
};

const getCurrentLearnerRequest = () => ({
  type: GET_CURRENT_LEARNER_REQEST,
});

const getCurrentLearnerSuccess = (user) => ({
  type: GET_CURRENT_LEARNER_SUCCESS,
  payload: user,
});

const getCurrentLearnerFailure = (error) => ({
  type: GET_CURRENT_LEARNER_FAILURE,
  payload: error,
});

export const getCurrentLearner = () => async (dispatch) => {
  dispatch(getCurrentLearnerRequest());
  try {
    const response = await api.get(`/learners/current`);
    const user = response.data;
    dispatch(getCurrentLearnerSuccess(user));
  } catch (error) {
    dispatch(getCurrentLearnerFailure(error.message));
  }
};

const getMyEnrolledCoursesRequest = () => ({
  type: GET_MY_ENROLLED_COURSES_REQUEST,
});

const getMyEnrolledCoursesSuccess = (courses) => ({
  type: GET_MY_ENROLLED_COURSES_SUCCESS,
  payload: courses,
});

const getMyEnrolledCoursesFailure = (error) => ({
  type: GET_MY_ENROLLED_COURSES_FAILURE,
  payload: error,
});

export const getMyEnrolledCourses = (page) => async (dispatch) => {
  dispatch(getMyEnrolledCoursesRequest());
  try {
    const response = await api.get(`/learners/my-courses?page=${page}`);
    const courses = response.data;
    dispatch(getMyEnrolledCoursesSuccess(courses));
  } catch (error) {
    dispatch(getMyEnrolledCoursesFailure(error.message));
  }
};

export const resetAllActions = () => ({
  type: RESET_ALL_ACTIONS,
});
